import { IonButton, IonIcon, IonInput } from "@ionic/react";
import { chevronDownOutline, chevronUpOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";

interface TimePickerProps {
  onTimeChange?: (time: string) => void;
}

const TimePicker: React.FC<TimePickerProps> = ({ onTimeChange }) => {
  const [hour, setHour] = useState(10);
  const [minute, setMinute] = useState(0);
  const [period, setPeriod] = useState("AM");

  const incrementHour = () => {
    if (hour === 11) {
      setHour(12);
      togglePeriod(); // Switch between AM and PM
    } else if (hour === 12) {
      setHour(1);
    } else {
      setHour(hour + 1);
    }
  };

  const decrementHour = () => {
    if (hour === 1) {
      setHour(12);
      togglePeriod(); // Switch between AM and PM
    } else if (hour === 12) {
      if (period === "PM") {
        setHour(11);
        togglePeriod(); // Switch from PM to AM
      } else {
        setHour(11);
      }
    } else {
      setHour(hour - 1);
    }
  };

  const incrementMinute = () => {
    if (minute === 59) {
      setMinute(0);
      incrementHour();
    } else {
      setMinute(minute + 1);
    }
  };

  const decrementMinute = () => {
    if (minute === 0) {
      setMinute(59);
      decrementHour();
    } else {
      setMinute(minute - 1);
    }
  };

  const togglePeriod = () => {
    setPeriod(period === "AM" ? "PM" : "AM");
  };

  const formattedMinute = `${minute}`.padStart(2, "0");
  const formattedTime = `${hour}:${formattedMinute} ${period}`;

  useEffect(() => {
    if (onTimeChange) onTimeChange(formattedTime);
    // eslint-disable-next-line
  }, [hour, minute, period, onTimeChange]);

  return (
    <div className="flex justify-between bg-primary-50 rounded-lg mx-4">
      <div className="flex items-center px-4">
        <div className="flex flex-col items-center justify-center">
          <IonButton onClick={incrementHour} fill="clear">
            <IonIcon slot="icon-only" icon={chevronUpOutline} />
          </IonButton>
          <IonInput readonly value={hour} className="text-center w-8 ml-2" />
          <IonButton onClick={decrementHour} fill="clear">
            <IonIcon slot="icon-only" icon={chevronDownOutline} />
          </IonButton>
        </div>
        <span>:</span>
        <div className="flex flex-col items-center justify-center">
          <IonButton onClick={incrementMinute} fill="clear">
            <IonIcon slot="icon-only" icon={chevronUpOutline} />
          </IonButton>
          <IonInput
            readonly
            value={formattedMinute}
            className="text-center w-8 ml-2"
          />
          <IonButton onClick={decrementMinute} fill="clear">
            <IonIcon slot="icon-only" icon={chevronDownOutline} />
          </IonButton>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center pr-2">
        <IonButton onClick={togglePeriod} fill="clear">
          <IonIcon slot="icon-only" icon={chevronUpOutline} />
        </IonButton>
        <IonInput readonly value={period} className="text-center w-12 ml-2" />
        <IonButton onClick={togglePeriod} fill="clear">
          <IonIcon slot="icon-only" icon={chevronDownOutline} />
        </IonButton>
      </div>
    </div>
  );
};

export default TimePicker;
